/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import Image20 from '@carbon/icons-react/es/image/20';
import { Editor } from '@ckeditor/ckeditor5-core/src/editor/editor';
import { Popover } from 'antd';
import React, { FC, useRef } from 'react';
import { useTranslation } from 'hooks/use-translation';
import styles from './image-uploader.module.css';

interface Props {
  editor: Editor;
}
export const ImageUploader: FC<Props> = ({ editor }: Props) => {
  const inputEl = useRef<HTMLInputElement>(null);

  const onChangeFile = (event) => {
    event.stopPropagation();
    event.preventDefault();
    const files = Array.from(event.target.files);

    editor.execute('uploadImage', { file: files });
    // Selecting the same file again should emit an onChange event.
    // eslint-disable-next-line no-param-reassign
    event.target.value = '';
  };

  const translatedLabel = useTranslation('toolbar.insert_image');

  return (
    <Popover
      placement="bottom"
      content={translatedLabel}
      overlayClassName={`${styles.tooltip}`}
    >
      <div
        className={styles.wrapper}
        onClick={() => {
          if (inputEl !== null) {
            inputEl?.current?.click();
          }
        }}
      >
        <input
          id="myInput"
          type="file"
          ref={inputEl}
          className="hide"
          onChange={onChangeFile}
          multiple
          accept="image/*"
        />
        <Image20 />
      </div>
    </Popover>
  );
};
